import React from 'react';
import { Button, Badge } from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import Table from '../../../shared/table/Table';

const STATUS_BADGE = {
  approved: { colorScheme: 'green', label: 'مقبول' },
  pending: { colorScheme: 'orange', label: 'بانتظار الموافقة' },
  rejected: { colorScheme: 'red', label: 'مرفوض' },
};

const ITEM_STATUS_BADGE = {
  available: { colorScheme: 'blue', label: 'متاح' },
  sold: { colorScheme: 'gray', label: 'تم البيع' },
  cancelled: { colorScheme: 'red', label: 'ملغى' },
};

const ShopItemsTable = ({ data, page, handleUpdate, handleDelete, handleApprove, handleReject }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>الاسم</th>
        <th>التصنيف</th>
        <th>النوع</th>
        <th>السعر</th>
        <th>السيرفر</th>
        <th>البائع</th>
        <th>الحالة</th>
        <th>حالة المنتج</th>
        <th>إجراءات</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((item, idx) => (
        <tr key={item._id}>
          <td>{(page - 1) * 10 + idx + 1}</td>
          <td>{item.name}</td>
          <td>{item.category}</td>
          <td>{item.type}</td>
          <td>{item.price}</td>
          <td>{item.server}</td>
          <td>{item.seller}</td>
          <td>
            <Badge colorScheme={STATUS_BADGE[item.status]?.colorScheme}>
              {STATUS_BADGE[item.status]?.label}
            </Badge>
          </td>
          <td>
            <Badge colorScheme={ITEM_STATUS_BADGE[item.item_status]?.colorScheme}>
              {ITEM_STATUS_BADGE[item.item_status]?.label}
            </Badge>
          </td>
          <td>
            {item.status !== 'approved' && (
              <Button bg="transparent" color="teal.300" size="xs" title="موافقة" onClick={() => handleApprove(item)}>
                <FiIcons.FiCheckCircle size={20} />
              </Button>
            )}
            {item.status !== 'rejected' && (
              <Button bg="transparent" color="orange.400" size="xs" title="رفض" onClick={() => handleReject(item)}>
                <FiIcons.FiXCircle size={20} />
              </Button>
            )}
            <Button bg="transparent" color="green" size="xs" onClick={() => handleUpdate(item)}>
              <FiIcons.FiEdit size={20} />
            </Button>
            <Button bg="transparent" color="red.600" size="xs" onClick={() => handleDelete(item)}>
              <FiIcons.FiDelete size={20} />
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default ShopItemsTable;
